module.exports = __webpack_public_path__ + "static/img/forward.af3a60db.svg";